import { Content } from './styles'

import { Container } from '../../styles/container'

export default function About() {
    return (
        <Container id="about">
            <Content>
                <h3>Quem somos</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio atque, quam maxime obcaecati tempore et ut. Velit pariatur, corporis odit nesciunt, incidunt consequatur suscipit reiciendis necessitatibus et nisi natus reprehenderit.
                Nobis quae ducimus laborum eos tempora repellendus sed voluptates dolor beatae distinctio id culpa, voluptate maiores, voluptas corporis vero ullam reiciendis quas delectus, sint dolorum. Adipisci sapiente dolores animi eum!
                Ea accusantium adipisci voluptate, beatae minima qui corrupti perferendis enim debitis. Nihil molestiae, eligendi perferendis natus autem officia numquam voluptates obcaecati tempora odit. Itaque voluptate, laudantium assumenda voluptas rem quis?</p>
            </Content>
        </Container>
    )
}